import React from "react";
import * as yup from "yup";
import { UploadTextField } from "../../../controls/UploadTextField/UploadTextField";
import { Target } from "../../../../models/Target";
import { UploadTargetSelect } from "../../../controls/UploadTargetSelect/UploadTargetSelect";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

export const StepTitle2 = (t: TFunction) => t("step2.title");
export const StepInstructions2 = (t: TFunction) => t("step2.instructions");
export const StepValidation2 = (t: TFunction) => {
  return yup.object({
    target: yup.object({
      name: yup.string().required(t("validation.target.required")),
    }),
    request: yup.object({
      message: yup
        .string()
        .required(t("validation.request.message.required"))
        .max(1024, t("validation.request.message.max", { max: 1024 })),
      code: yup.string().max(16, t("validation.request.code.max")),
    }),
  });
};

interface Step2Props {
  targets: Target[];
  codeLabel: string;
}

export const Step2: React.FC<Step2Props> = ({ targets, codeLabel }) => {
  const { t } = useTranslation();
  const message = t("step2.message")+" *";
  let code = codeLabel;
  if (code.length === 0)
    code = t("step2.code");

  return (
    <>
      <div>
        <UploadTargetSelect
          label={t("step2.receiver")+" *"}
          name="target"
          targets={targets}
          autoFocus
        />
      </div>
      <div>
        <UploadTextField
          label={message}
          placeholder={message}
          name="request.message"
          type="text"
          multiline={true}
          lines={4}
          outlined={true}
        />
      </div>
      <div>
        <UploadTextField
          label={code}
          placeholder={code}
          name="request.code"
          type="text"
          maxLength={16}
        />
      </div>
    </>
  );
};
